export default "__VITE_PUBLIC_ASSET__3956de4b__"